import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { hasBannerAdmin, isAdminLocalDev } from './adminAccess'

export { hasBannerAdmin } from './adminAccess'

// The banner admin surface (/admin/banners) is gated on the service-role-only
// GoTrue app_metadata.role === 'admin' claim. The backend require_admin 403 is
// the real boundary — this just hides the route so non-admins never see it.
// Local dev bypasses, like AdminTopupRoute / ProtectedRoute.
//
// Reads app_metadata ONLY — user_metadata is client-editable and must never gate
// an admin affordance. The claim is baked into the JWT at issue time, so a freshly
// granted admin only sees the route after a token refresh / re-login (accepted:
// the backend 403 stays authoritative until then).
export default function BannerAdminRoute() {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (isAdminLocalDev() || hasBannerAdmin(user)) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
